"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpeningState = exports.BanditManchotWhisperer = exports.ZpdesHssbgGraph = exports.ZpdesHssbg = void 0;
exports.ZpdesHssbg = __importStar(require("./zpdes"));
exports.ZpdesHssbgGraph = __importStar(require("./zpdes-graph"));
exports.BanditManchotWhisperer = __importStar(require("./bandit-manchot-whisperer"));
var bm_types_1 = require("./bm.types");
Object.defineProperty(exports, "OpeningState", { enumerable: true, get: function () { return bm_types_1.OpeningState; } });
// If we want 2 versions of ZPDES (one for production and one for test), create two TS files for ZPDES and export both of them
